import React from "react";
import { Container, Row, Col, Button, Card, Form, Image } from "react-bootstrap";

const CustomEdgeFabricationLanding: React.FC = () => {
  return (
    <div style={{ fontFamily: "Segoe UI, sans-serif" }}>
      {/* Hero Section */}
      <div className="bg-dark text-white text-center py-5">
        <Container>
          <h1 className="display-4">Custom Edge Fabrication</h1>
          <p className="lead">Precision Crafted. Built to Last.</p>
          <Button variant="primary" size="lg">Request a Quote</Button>
        </Container>
      </div>

      {/* Services Section */}
      <Container className="my-5">
        <h2 className="text-center mb-4">Our Custom Fabrication Services</h2>
        <Row>
          {[
            {
              title: "Aluminum Edging",
              text: "Durable and corrosion-resistant aluminum edges for any project.",
              img: "https://source.unsplash.com/400x300/?aluminum,metal"
            },
            {
              title: "Steel Custom Cuts",
              text: "Precision laser-cut steel components and frames.",
              img: "https://source.unsplash.com/400x300/?steel,fabrication"
            },
            {
              title: "Architectural Finishes",
              text: "Polished and powder-coated finishes for high-end design.",
              img: "https://source.unsplash.com/400x300/?metal,architecture"
            }
          ].map(({ title, text, img }, idx) => (
            <Col md={4} key={idx} className="mb-4">
              <Card>
                <Card.Img variant="top" src={img} />
                <Card.Body>
                  <Card.Title>{title}</Card.Title>
                  <Card.Text>{text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Gallery Section */}
      <div className="bg-light py-5">
        <Container>
          <h2 className="text-center mb-4">Project Gallery</h2>
          <Row>
            {[1, 2, 3, 4].map((n) => (
              <Col md={3} sm={6} xs={12} key={n} className="mb-4">
                <Image
                  src={`https://source.unsplash.com/400x300/?fabrication,metal,${n}`}
                  thumbnail
                  alt={`Custom Work ${n}`}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Quote Request Form */}
      <Container className="my-5">
        <h2 className="text-center mb-4">Get a Custom Quote</h2>
        <Row className="justify-content-center">
          <Col md={8}>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group controlId="formName" className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter your name" />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formEmail" className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" placeholder="Enter your email" />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="formService" className="mb-3">
                <Form.Label>Service Needed</Form.Label>
                <Form.Select>
                  <option>Aluminum Edging</option>
                  <option>Steel Cutting</option>
                  <option>Architectural Finishing</option>
                  <option>Other</option>
                </Form.Select>
              </Form.Group>
              <Form.Group controlId="formDetails" className="mb-3">
                <Form.Label>Project Details</Form.Label>
                <Form.Control as="textarea" rows={4} placeholder="Describe your project needs..." />
              </Form.Group>
              <div className="text-center">
                <Button variant="success" type="submit">Submit Quote Request</Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>

      {/* Footer */}
      <div className="bg-dark text-white text-center py-4">
        <Container>
          <p>© {new Date().getFullYear()} Custom Edge Fabrication | (555) 123-4567 | info@customedgefab.com</p>
        </Container>
      </div>
    </div>
  );
};

export default CustomEdgeFabricationLanding;
